module.exports = __webpack_public_path__ + "static/media/c-more-sport-1.12fde1ab.png";